import React from 'react';
import './cancel-modal.scss';
import { SwipeableDrawer } from '@mui/material';
import { SVGS } from '../../../assets';
import { CommonButton } from '@zonofi/seller-hub/components';

interface CancelModalProps {
  open: boolean;
  onClose: () => void;
  onCancelPress: () => void;
  isLoading?: boolean;
}

export const CancelModal: React.FC<CancelModalProps> = ({
  open,
  onClose,
  onCancelPress,
  isLoading,
}) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen={true}
      PaperProps={{
        className: 'cancel-modal__drawer-paper',
        role: 'dialog',
      }}
    >
      <div className="cancel-modal__content">
        <img src={SVGS.CancelOrderIcon} alt="" />

        <div className="cancel-modal__content-text font-semibold">
          {'Are you sure you want to cancel this order?'}
        </div>

        <div className="cancel-modal__content-button">
          <CommonButton
            text={'Cancel Order'}
            onPress={onCancelPress}
            loading={isLoading}
            spinnerColor="#fff"
            spinnerSize={22}
          />
          <CommonButton
            text={'Go Back'}
            buttonStyle="cancel-modal__content-back-button"
            textStyle="cancel-modal__content-back-button-text"
            onPress={onClose}
          />
        </div>
      </div>
    </SwipeableDrawer>
  );
};
